import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {useLanguage} from "../../LanguageContext";
import {sectionTitle} from "../styles/CommonStyles";

const aboutUsContainer = {
    position: 'relative',
    p: '20px',
    pt: '70px',
    pb: '70px',
    mx: "auto",
    width: "100%",
    backgroundColor: '#ffffff',
    color: "#000000",
    alignContent: 'center',
};

const aboutUsDescriptionContainer = {
    width: {
        xs: '100%',
        sm: '80%',
        md: '90%',
        lg: '60%',
    },
    ml: {
        xs: '0',
        sm: '10%',
        md: '5%',
        lg: '20%',
    }
};
const aboutUsDescriptionText = {
    fontFamily: "Jost-Regular",
    fontSize: '20px',
    color: 'black',
    pb: '36px'
};

const AboutUsSection = () => {
    const {t} = useLanguage();


    return (
        <Box sx={aboutUsContainer}>
            <Grid container spacing={4}
                  alignItems="center"
                  justifyContent="center">
                <Grid item xs={12} sm={12} md={9} lg={9}>
                    <Box textAlign={'center'} pb={'24px'}>
                        <Typography sx={sectionTitle}>
                            {t('about_us_title')}
                        </Typography>
                    </Box>
                    <Box sx={aboutUsDescriptionContainer}>
                        {t('about_us_paragraphs').map((text, index) => {
                            return (
                                <Box textAlign={'center'} key={index}>
                                    <Typography
                                        sx={aboutUsDescriptionText}>
                                        {text}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AboutUsSection;
